import Vue from 'vue';
import _ from "lodash";
import industryAPI from "../api/industry";
import common from '../../libs/common';

const types = {
    LOADING: 'LOADING',
    SET_FIELD: 'SET_FIELD',
    SET_SORT_FIELD: 'SET_SORT_FIELD',
    LOADING_BY_KEY: 'LOADING_BY_KEY',
    GET_COMPETITORS_OK: 'GET_COMPETITORS_OK',
    LINE_CHART_COMPETITORS_OK: 'LINE_CHART_COMPETITORS_OK',
    BUBBLE_CHART_COMPETITORS_OK: 'BUBBLE_CHART_COMPETITORS_OK',
    LINE_INVENTORIES_OK: 'LINE_INVENTORIES_OK'
};

const initState = {
    form: {},
    sort: {
        field: "mos",
        order: "desc"
    },
    competitors: {},
    inventories: {
        series: [],
        chartOptions: {
            chart: {
                width: 350,
                type: 'line',
                id: 'areachart-2',
                animations: {
                    enabled: false
                }
            },
            colors: ['var(--purple-dark)', 'var(--green)', 'var(--yellow)'],
            dataLabels: {
                enabled: false
            },
            tooltip: {
                custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                    const seriesItem = w.config.series[0];
                    const seriesItem1 = w.config.series[1];
                    const seriesItem2 = w.config.series[2];
                    const data = (seriesItem.data[dataPointIndex]*100).toFixed(2);
                    const data1 = (seriesItem1.data[dataPointIndex]*100).toFixed(2);
                    const data2 = (seriesItem2.data[dataPointIndex]*100).toFixed(2);
                    const dataValue = (seriesItem.values[dataPointIndex]).toFixed();
                    const dataValue1 = (seriesItem1.values[dataPointIndex]).toFixed();
                    const dataValue2 = (seriesItem2.values[dataPointIndex]).toFixed();
                    return `<div class="custom-tooltip">
                              <p><b>${seriesItem.name}:</b> ${data}% (${dataValue} B)</p>
                              <p><b>${seriesItem1.name}:</b> ${data1}% (${dataValue1} B)</p>
                              <p><b>${seriesItem2.name}:</b> ${data2}% (${dataValue2} B)</p>
                            </div>`;
                },
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                tickAmount: 10
            },
            yaxis: {
                labels: {
                    formatter: function (value) {
                        return (value * 100).toFixed() + '%';
                    }
                },
                tooltip: {
                    enabled: true
                }
            },
        }
    },
    lineCompetitors: {
        series: [],
        chartOptions: {
            chart: {
                width: 350,
                type: 'line',
                id: 'areachart-2',
                animations: {
                    enabled: false
                }
            },
            colors: ['var(--yellow)', 'var(--purple-dark)'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                show: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (timestamp) {
                        var formattedDate = common.formatDate(timestamp);
                        return formattedDate;
                    }
                },
                tickAmount: 10
            },
            yaxis: {
                labels: {
                    formatter: function (value) {
                        return (value * 100).toFixed() + "%";
                    }
                },
                tooltip: {
                    enabled: true
                }
            },
        }
    },
    bubbleCompetitors: {
        series: [],
        chartOptions: {
            plotOptions: {
                bubble: {
                    zScaling: true,
                    minBubbleRadius: 5,
                    maxBubbleRadius: 60,
                },
            },
            dataLabels: {
                enabled: false,
                // formatter: function (val, opts) {
                //   const zValue = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].z;
                //   return zValue.toFixed(2); // Format z value to 2 decimal places
                // }
            },
            grid: {
                show: false
            },
            xaxis: {
                // min: 0,
                // max: 100,
                title: {
                    text: "MOS",
                },
                tickAmount: 5,
            },
            yaxis: {
                min: 0,
                max: 10,
                labels: {
                    formatter: function (value) {
                        return (value).toFixed();
                    }
                },
                title: {
                    text: "DCA",
                },
                tickAmount: 5,
            },
            tooltip: {
                enabled: true,
                shared: false,
                custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                    const data = w.config.series[seriesIndex].data[dataPointIndex];
                    return `
                        <div style="padding: 10px; border-radius: 5px; background: #fff; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);">
                        <strong>${w.config.series[seriesIndex].name}</strong><br>
                        MOS: ${data.x.toFixed(1)}%<br>
                        DCA: ${data.y.toFixed(1)}<br>
                        Percentage: ${(data.z / 100).toFixed(2)}%
                        </div>
                    `;
                },
            },
            legend: {
                position: "bottom",
            },
            fill: {
                opacity: 0.8,
            },
        }
    },
}

const getters = {
    form: state => state.form,
    sort: state => state.sort,
    loading: state => state.loading,
    competitors: state => state.competitors,
    lineCompetitors: state => state.lineCompetitors,
    bubbleCompetitors: state => state.bubbleCompetitors,
    inventories: state => state.inventories
}

const actions = {
    setField({ commit }, { key, value }) {
        commit(types.SET_FIELD, { key, value });
    },

    setSortField({ commit }, { key, value }) {
        commit(types.SET_SORT_FIELD, { key, value });
    },

    async getCompetitors({ state, commit, dispatch }, code) {
        try {
            commit('LOADING_BY_KEY', { key: "competitorsListLoading", status: true });
            const formData = {
                "search": "",
                "sort": state.sort,
                "page": 1,
                "limit": 50
            };
            const { data } = await industryAPI(dispatch).getCompetitors(code, formData);
            if (data) {
                commit(types.GET_COMPETITORS_OK, data.items);
            } else {
                Vue.$log.error("Get stock same sector fail", e);
            }
        } catch (e) {
            Vue.$log.error("Get stock same sector fail", e);
            commit('LOADING_BY_KEY', { key: "competitorsListLoading", status: false });
        }
    },

    async getIndicatorLineChart({ commit, dispatch }, params) {
        try {
            commit('LOADING_BY_KEY', { key: "lineInventoriesLoading", status: true });
            const { data } = await industryAPI(dispatch).getIndicatorLineChart(params.symbol, params.indicator);
            commit(types.LINE_INVENTORIES_OK, data);
        } catch (e) {
            Vue.$log.error("Get line inventories failed", e);
            commit('LOADING_BY_KEY', { key: "lineInventoriesLoading", status: false });
        }
    },

    async getLineChartCompetitors({ commit, dispatch }, params) {
        try {
            commit('LOADING_BY_KEY', { key: "lineChartCompetitorsLoading", status: true });
            const { data } = await industryAPI(dispatch).getLineChartCompetitors(params.symbol, params.period);
            commit(types.LINE_CHART_COMPETITORS_OK, data);
        } catch (e) {
            Vue.$log.error("Get line chart competitors failed", e);
            commit('LOADING_BY_KEY', { key: "lineChartCompetitorsLoading", status: false });
        }
    },

    async getBubbleChartCompetitors({ commit, dispatch }, symbol) {
        try {
            commit('LOADING_BY_KEY', { key: "bubbleChartCompetitorsLoading", status: true });
            const { data } = await industryAPI(dispatch).getBubbleChartCompetitors(symbol);
            commit(types.BUBBLE_CHART_COMPETITORS_OK, data);
        } catch (e) {
            Vue.$log.error("Get bubble chart competitors failed", e);
            commit('LOADING_BY_KEY', { key: "bubbleChartCompetitorsLoading", status: false });
        }
    },
}

const mutations = {
    [types.SET_FIELD](state, params) {
        Vue.set(state.form, params.key, params.value);
    },
    [types.SET_SORT_FIELD](state, params) {
        Vue.set(state.sort, params.key, params.value);
    },
    [types.LOADING](state, loading) {
        Vue.set(state, 'loading', loading);
    },
    [types.LOADING_BY_KEY](state, data) {
        Vue.set(state.form, data.key, data.status);
    },

    [types.LINE_INVENTORIES_OK](state, data) {
        Vue.set(state.inventories, 'series', data.items);
        Vue.set(state.inventories.chartOptions, 'labels', data.titles);
        Vue.set(state.form, 'lineInventoriesLoading', false);
    },

    [types.LINE_CHART_COMPETITORS_OK](state, data) {
        Vue.set(state.lineCompetitors, 'series', data.items);
        Vue.set(state.lineCompetitors.chartOptions, 'labels', data.dates);
        Vue.set(state.form, 'lineChartCompetitorsLoading', false);
    },

    [types.BUBBLE_CHART_COMPETITORS_OK](state, data) {
        Vue.set(state.bubbleCompetitors, 'series', data);
        Vue.set(state.form, 'bubbleChartCompetitorsLoading', false);
    },

    [types.GET_COMPETITORS_OK](state, data) {
        Vue.set(state, 'competitors', data);
        Vue.set(state.form, 'competitorsListLoading', false);
    },
}

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations
};